// Centralized chart styling constants.
// These mirror the Less tokens (styles/tokens.less) so chart option builders
// never hardcode colors inline (see T04 acceptance criteria).

export const CHART_FONT_FAMILY = "'Noto Sans JP', sans-serif";

export const CHART_COLORS = {
  /** Primary company series (red). */
  seriesPrimary: '#e60000',
  /** Industry / comparison series (gray). */
  seriesCompare: '#5a5a5a',
  /** Radar grid line color from the Figma score component. */
  radarGrid: '#999999',
  /** Grid lines and splitlines. */
  grid: '#e0e0e0',
  /**
   * Subtle grid color from the v20 design system
   * (Figma token `border/decorative-subtle`, mirrors
   * `@color-border-decorative-subtle` in styles/tokens.less).
   */
  gridSubtle: '#d6d6d6',
  /** Axis labels / muted text. */
  axisLabel: '#484848',
  /** Default text. */
  text: '#333333',
  /** Positive value (JP convention: red = up). */
  positive: '#e60000',
  /** Negative value (blue = down). */
  negative: '#1565c0',
} as const;

/** Neutral native-scrollbar look; mirrors surface-soft / tab-active Less tokens. */
export const CHART_SCROLLBAR_COLORS = {
  track: '#f4f4f4',
  thumb: '#838383',
} as const;

/**
 * Five-segment consensus palette, ordered:
 * 強気, やや強気, 中立, やや弱気, 弱気.
 */
export const CONSENSUS_PALETTE = [
  '#e60000', // 強気
  '#e28d8d', // やや強気
  '#acacac', // 中立
  '#7d9eff', // やや弱気
  '#3366ff', // 弱気
] as const;

export const CONSENSUS_LABELS = ['強気', 'やや強気', '中立', 'やや弱気', '弱気'] as const;

/**
 * Financial chart series colors (Balance / Cash Flow / R&D grouped bars).
 * Kept separate from the consensus palette so each can evolve independently.
 */
export const FINANCIAL_COLORS = {
  red: '#e60000',
  blue: '#337ebc',
  purple: '#aa5194',
} as const;

/** Value tone colors used by the Trends matrix tables. */
export const VALUE_TONE_COLORS = {
  positive: '#cc0100',
  negative: '#3366ff',
  default: '#484848',
} as const;

/** Default base text style applied to every chart by BaseEChart. */
export const CHART_TEXT_STYLE = {
  fontFamily: CHART_FONT_FAMILY,
  color: CHART_COLORS.text,
} as const;

/** Figma Body(S)/Medium style for chart axis labels. */
export const CHART_AXIS_LABEL_STYLE = {
  color: CHART_COLORS.axisLabel,
  fontSize: 12,
  fontWeight: 500,
  fontFamily: CHART_FONT_FAMILY,
  letterSpacing: -0.4,
} as const;
